var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PinSpaceRepository } from '../repository/pin-space-repository.interface';
import { SpacesModel } from '../model/spaces-model';
let PinSpaceServiceImpl = class PinSpaceServiceImpl {
    constructor(_pinSpaceRepository, _spacesModel) {
        this._pinSpaceRepository = _pinSpaceRepository;
        this._spacesModel = _spacesModel;
    }
    _pinAndResortSpaces(spaceId) {
        this._spacesModel.update((spaces) => {
            const _index = spaces.findIndex(space => space.spaceId === spaceId);
            const [targetItem] = spaces.splice(_index, 1); // 移除找到的元素
            targetItem.topSpace = true;
            spaces.unshift(targetItem);
            return spaces;
        });
    }
    _unpinAndResortSpaces(spaceId) {
        this._spacesModel.update((spaces) => {
            const _index = spaces.findIndex(space => space.spaceId === spaceId);
            const [targetItem] = spaces.splice(_index, 1); // 移除找到的元素
            targetItem.topSpace = false;
            spaces.push(targetItem);
            return spaces;
        });
    }
    pinSpace(spaceId, isPin) {
        if (isPin) {
            this._pinAndResortSpaces(spaceId);
        }
        else {
            this._unpinAndResortSpaces(spaceId);
        }
        return this._pinSpaceRepository.pinSpace(spaceId, isPin);
    }
};
PinSpaceServiceImpl = __decorate([
    injectable(),
    __param(0, inject(PinSpaceRepository)),
    __param(1, inject(SpacesModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof PinSpaceRepository !== "undefined" && PinSpaceRepository) === "function" ? _a : Object, typeof (_b = typeof SpacesModel !== "undefined" && SpacesModel) === "function" ? _b : Object])
], PinSpaceServiceImpl);
export { PinSpaceServiceImpl };
